import { httpStatuses } from '@reveni-io/reveni-ui'

export const visibleOrdersCount = 10
export const invalidLinkStatuses = [httpStatuses.unauthorized, httpStatuses.forbidden]
